import { FaBars, FaCar, FaCarSide, FaChevronDown, FaCartPlus, FaCube, FaCubes, FaHome, FaPlusCircle, FaPlusSquare, FaStore, FaTag, FaTags, FaTimes, FaTools, FaTrademark, FaUserCog, FaUserPlus, FaUsers, FaUserShield, FaUserTie, FaWarehouse, FaWrench } from 'react-icons/fa';
import { FaCartShopping } from "react-icons/fa6";
import { MdCategory } from "react-icons/md";
import { FcStatistics } from "react-icons/fc";
import { MdOutlineCategory } from "react-icons/md";
import { CgAttribution } from "react-icons/cg";
import { FaBoxArchive } from "react-icons/fa6";
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
import { IoNotifications } from "react-icons/io5";
import { FaCartArrowDown } from "react-icons/fa";
import { LiaAdSolid } from "react-icons/lia";
import { FaUserAlt } from "react-icons/fa";
import { FaPager } from "react-icons/fa";
import { IoNewspaperOutline } from "react-icons/io5";
import { AiTwotoneDatabase } from "react-icons/ai";
import { MdOutlineInput } from "react-icons/md";
import { RiVisaLine } from "react-icons/ri";
import { BsFillSendFill } from "react-icons/bs";
import { FaArrowDown } from "react-icons/fa6";
import { ImArrowUpRight } from "react-icons/im";
import { ImArrowDownLeft } from "react-icons/im";
import { FaAdversal } from "react-icons/fa";
import { MdReport } from "react-icons/md";
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import AdUnitsIcon from '@mui/icons-material/AdUnits';
import { IoMdPhotos } from "react-icons/io";
import i18n from "../lib/i18n"; // path may differ

const t = i18n.t.bind(i18n); 

const navigationItems = [
    { icon: <FaHome />, section: "Analytics", permissions: "statistics.view", text: t("nav.dashboard"), to: "/" },
    // { icon: <FcStatistics />, section: "Analytics", permissions: "brands.view", text: "الاحصائيات", to: "/statistics" },
    { icon: <FaCartArrowDown />, section: "Orders & Advertising", permissions: "orders.view", text: t("nav.orders"), to: "/orders" },
    { icon: <FaAdversal />, section: "Orders & Advertising", permissions: "ads.view", text: t("nav.ads"), to: "/ads" },
    { icon: <IoChatbubbleEllipsesSharp />, section: "Messages & Alerts", permissions: "reports.view", text: t("nav.chats"), to: "/chats" },
    {
        icon: <IoNotifications />,
        permissions: "notifications.view",
        text: t("nav.notifications"),
        section: "Messages & Alerts",
        subItems: [
            { icon: <ImArrowDownLeft />, text: t("nav.incoming_notifications"), to: "/notifications", permissions: "notifications.view" },
            { icon: <ImArrowUpRight />, text: t("nav.outgoing_notifications"), to: "/notifications/outgoing", permissions: "notifications.view" },
            { icon: <FaPlusCircle />, text: t("nav.send_notification"), to: "/notifications/add", permissions: "notifications.view" }
        ]
    },
    {
        icon: <MdOutlineCategory />,
        permissions: "categories.view",
        text: t("nav.categories"),
        section: "Catalog & Config",
        subItems: [
            { icon: <MdOutlineCategory />, text: t("nav.categories"), to: "/categories", permissions: "categories.view" },
            { icon: <FaPlusCircle />, text: t("nav.add_category"), to: "/categories/add", permissions: "categories.create" }
        ]
    },
    {
        icon: <MdOutlineInput />,
        permissions: "inputs.view",
        text: t("nav.inputs"),
        section: "Catalog & Config",
        subItems: [
            { icon: <MdOutlineInput />, text: t("nav.inputs"), to: "/inputs", permissions: "inputs.view" },
            { icon: <FaPlusCircle />, text: t("nav.add_input"), to: "/inputs/add", permissions: "inputs.create" }
        ]
    },
    {
        icon: <FaBoxArchive />,
        permissions: "packages.view",
        text: t("nav.packages"),
        section: "Catalog & Config",
        subItems: [
            { icon: <FaBoxArchive />, text: t("nav.packages"), to: "/packages", permissions: "packages.view" },
            { icon: <FaCartPlus />, text: t("nav.add_package"), to: "/packages/add", permissions: "packages.create" }
        ]
    },
    { icon: <RiVisaLine />, section: "Catalog & Config", permissions: "payments.view", text: t("nav.payment_methods"), to: "/paymentMethod" },
    { icon: <FaUserAlt />, section: "User & Reports", permissions: "users.view", text: t("nav.users"), to: "/users" },
    { icon: <MdReport className='text-[22px]' />, section: "User & Reports", permissions: "reports.view", text: t("nav.reports"), to: "/reports" },
    {
        icon: <FaUserShield />,
        permissions: "roles.view",
        text: t("nav.roles"),
        section: "Employee & Role Management",
        subItems: [
            { icon: <FaUserCog />, text: t("nav.roles"), to: "/roles", permissions: "roles.view" },
            { icon: <FaPlusCircle />, text: t("nav.add_role"), to: "/roles/add", permissions: "roles.create" }
        ]
    },
    {
        icon: <FaUsers />,
        permissions: "employees.view",
        section: "Employee & Role Management",
        text: t("nav.employees"),
        subItems: [
            { icon: <FaUserTie />, text: t("nav.employees"), to: "/employees", permissions: "employees.view" },
            { icon: <FaUserPlus />, text: t("nav.add_employee"), to: "/employees/add", permissions: "employees.create" }
        ]
    },
    {
        icon: <ViewCarouselIcon />,
        permissions: "banners.view",
        text: t("nav.banners"),
        section: "Content Management",
        subItems: [
            { icon: <ViewCarouselIcon />, text: t("nav.banners"), to: "/banners", permissions: "banners.view" },
            { icon: <FaPlusCircle />, text: t("nav.add_banner"), to: "/banners/add", permissions: "banners.create" }
        ]
    },
    {
        icon: <AdUnitsIcon />,
        permissions: "marketing_promotions.view",
        text: t("nav.marketing"),
        section: "Content Management",
        subItems: [
            { icon: <AdUnitsIcon />, text: t("nav.marketing"), to: "/marketingPromotion", permissions: "marketing_promotions.view" },
            { icon: <FaPlusCircle />, text: t("nav.add_marketing"), to: "/marketingPromotion/add", permissions: "marketing_promotions.view" }
        ]
    },
    {
        icon: <FaPager />,
        permissions: "pages",
        text: t("nav.pages"),
        section: "Content Management",
        subItems: [
            { icon: <FaPager />, text: t("nav.pages"), to: "/pages", permissions: "pages" },
            { icon: <FaPlusCircle />, text: t("nav.add_page"), to: "/pages/add", permissions: "pages" }
        ]
    },
    {
        icon: <AiTwotoneDatabase />,
        permissions: "pages",
        text: t("nav.page_sections"),
        section: "Content Management",
        subItems: [
            { icon: <AiTwotoneDatabase />, text: t("nav.page_sections"), to: "/pageSections", permissions: "pages" },
            { icon: <FaPlusCircle />, text: t("nav.add_section"), to: "/pageSections/add", permissions: "pages" }
        ]
    },
    {
        icon: <IoNewspaperOutline />,
        permissions: "blogs.view",
        text: t("nav.blogs"),
        section: "Content Management",
        subItems: [
            { icon: <IoNewspaperOutline />, text: t("nav.blogs"), to: "/blogs", permissions: "blogs.view" },
            { icon: <FaPlusCircle />, text: t("nav.add_blog"), to: "/blogs/add", permissions: "blogs.view" }
        ]
    },
    {
        icon: <MdOutlineCategory />,
        permissions: "blog_categories.view",
        text: t("nav.blog_categories"),
        section: "Content Management",
        subItems: [
            { icon: <MdOutlineCategory />, text: t("nav.blog_categories"), to: "/categoriesBlog", permissions: "blog_categories.view" },
            { icon: <FaPlusCircle />, text: t("nav.add_blog_category"), to: "/blog/categories/add", permissions: "blog_categories.view" }
        ]
    },
];

const categoiresColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.name_ar"), key: "name.ar" },
    { header: t("columns.name_en"), key: "name.en" },
    { header: t("columns.parent_id"), key: "category_parent_id" },
    { header: t("columns.parent_name"), key: "category_parent_name" },
    { header: t("columns.status"), key: "active" },
  ];

  const statusOfCategories = [
    { id: "main", name: t("status.main") },
    { id: "sub", name: t("status.sub") },
  ];

  // 🟢 Inputs
  const inputsColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.name_ar"), key: "label.ar" },
    { header: t("columns.name_en"), key: "label.en" },
    { header: t("columns.type"), key: "type" },
    { header: t("columns.required"), key: "required" },
    { header: t("columns.regex"), key: "regex" },
  ];

  const typeOfInputs = [
    { id: "text", name: t("types.text") },
    { id: "number", name: t("types.number") },
    { id: "select", name: t("types.select") },
    { id: "check box", name: t("types.checkbox") },
  ];

  // 🟢 Packages
  const packagesColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.title_ar"), key: "title.ar" },
    { header: t("columns.title_en"), key: "title.en" },
    { header: t("columns.sub_category_name"), key: "sub_category_name" },
    { header: t("columns.price"), key: "price" },
    { header: t("columns.duration"), key: "duration" },
    { header: t("columns.top_result"), key: "topResult" },
    { header: t("columns.position"), key: "position" },
  ];

  const positionOfPackags = [
    { id: "1", name: t("positions.normal") },
    { id: "2", name: t("positions.home") },
  ];

  const shapOfPackags = [
    { id: "1", name: t("positions.normal_shape") },
    { id: "2", name: t("positions.vip_shape") },
  ];

  const TopResultOfPackags = [
    { id: "1", name: t("topResults.primary") },
    { id: "0", name: t("topResults.secondary") },
  ];

  // 🟢 Users
  const usersColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.photo"), key: "photo" },
    { header: t("columns.full_name"), key: "first_name" },
    { header: t("columns.type"), key: "type" },
    { header: t("columns.status"), key: "status" },
    { header: t("columns.confirmed"), key: "confirmed" },
    { header: t("columns.created_at"), key: "created_at" },
    { header: t("columns.active_ads"), key: "number_active_order" },
  ];

  const stateOfusers = [
    { id: "1", name: t("states.active") },
    { id: "2", name: t("states.banned") },
    { id: "3", name: t("states.suspended") },
  ];

  const typeOfUsers = [
    { id: "user", name: t("types.user") },
    { id: "company", name: t("types.company") },
  ];

  // 🟢 Orders
  const ordersColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.photo"), key: "ad_main_img" },
    { header: t("columns.full_name"), key: "full_name" },
    { header: t("columns.title_en"), key: "package_title" },
    { header: t("columns.price"), key: "price" },
    { header: t("columns.payment_method"), key: "payment_method" },
    { header: t("columns.created_at"), key: "created_at" },
    { header: t("columns.order_status"), key: "order_status" },
  ];

  const stateOfOrders = [
    { id: "PENDING", name: t("status.pending") },
    { id: "CONFIRM", name: t("status.confirm") },
    { id: "SoldRemoved", name: t("status.sold_removed") },
    { id: "REJECT", name: t("status.reject") },
  ];

  // 🟢 Ads
  const adsColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.photo"), key: "main_photo" },
    { header: t("columns.full_name"), key: "full_name" },
    { header: t("columns.title_en"), key: "title" },
    { header: t("columns.category_name"), key: "category_name" },
    { header: t("columns.sub_category_name"), key: "sub_category_name" },
    { header: t("columns.price"), key: "price" },
    { header: t("columns.publish_at"), key: "publish_at" },
    { header: t("columns.order_status"), key: "order" },
  ];

  const typeOfcurrency = [
    { id: "usd", name: t("types.usd") },
    { id: "sp", name: t("types.sp") },
  ];

  const typeOfAds = [
    { id: "CONFIRM", name: t("status.confirm") },
    { id: "PENDING", name: t("status.pending") },
    { id: "SoldRemoved", name: t("status.sold_removed") },
    { id: "REJECT", name: t("status.reject") },
  ];

  // 🟢 Blog Categories
  const categoriesBolgColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.name_ar"), key: "name.ar" },
    { header: t("columns.name_en"), key: "name.en" },
    { header: t("columns.isHome"), key: "isHome" },
    { header: t("columns.status"), key: "active" },
  ];

  const statusOfCategoriesBlog = [
    { id: "0", name: t("status.inactive") },
    { id: "1", name: t("status.active") },
  ];

  const positionOfCategoiresBlog = [
    { id: "0", name: t("positions.normal") },
    { id: "1", name: t("positions.home") },
  ];

  // 🟢 Blogs
  const bolgColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.photo"), key: "image" },
    { header: t("columns.title_ar"), key: "title.ar" },
    { header: t("columns.title_en"), key: "title.en" },
    { header: t("columns.category_name"), key: "category_name" },
  ];

  // 🟢 Payment Methods
  const paymentMethodColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.name_en"), key: "name" },
    { header: t("columns.status"), key: "active" },
  ];

  // 🟢 Roles
  const rolesColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.name_en"), key: "name" },
  ];

  // 🟢 Employees
  const employeesColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.full_name"), key: "name" },
    { header: t("columns.email"), key: "email" },
    { header: t("columns.role_id"), key: "role_id" },
    { header: t("columns.role_name"), key: "role_name" },
  ];

  // 🟢 Reports
  const reportsColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.reported_type"), key: "reported_type" },
    { header: t("columns.user_by_name"), key: "user_by.name" },
    { header: t("columns.reported_user_name"), key: "reported_user.name" },
    { header: t("columns.ad_name"), key: "reported_ad.title" },
    { header: t("columns.reason"), key: "report.report" },
    { header: t("columns.created_at"), key: "created_at" },
    { header: t("columns.check"), key: "check" },
  ];

  
  const reportType = [
    {name: t("types.user_report") , id : "user"},
    {name: t("types.chat") , id : "chat"},
    {name: t("types.ad") , id : "ad"}
  ];
  
  // 🟢 Number of Results
  const numberOfData = [
    { id: "10", name: t("resultsCount.10") },
    { id: "100", name: t("resultsCount.100") },
    { id: "200", name: t("resultsCount.200") },
    { id: "500", name: t("resultsCount.500") },
    { id: "1000", name: t("resultsCount.1000") },
    { id: "10000", name: t("resultsCount.10000") },
  ];
  
  const pageColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.title_ar"), key: "name.ar" },
    { header: t("columns.title_en"), key: "name.en" },
  ];
  
  const pageSectionColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.title_ar"), key: "title.ar" },
    { header: t("columns.title_ar"), key: "title.en" },
    { header: t("columns.description_ar"), key: "description.ar" },
    { header: t("columns.description_en"), key: "description.en" },
    { header: t("columns.page_name"), key: "page_name" },
  ];

  const bannerColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.photo"), key: "banner" },
    { header: t("columns.link"), key: "link" },
    { header: t("columns.status"), key: "active" },
  ];

  const marketingColumns = [
    { header: t("columns.id"), key: "id" },
    { header: t("columns.photo"), key: "promotion" },
    { header: t("columns.link"), key: "link" },
    { header: t("columns.start_time"), key: "start_time" },
    { header: t("columns.end_time"), key: "end_time" },
    { header: t("columns.devices"), key: "devices" },
    { header: t("columns.positions"), key: "positions" },
  ];

  const devices = [
    { id: "1", name: t("devices.website") },
    { id: "2", name: t("devices.phone") },
  ];

  const marketingPromotionPosition = [
    { id: "1", name: t("marketingPromotionPosition.HOME_PAGE") },
    { id: "2", name: t("marketingPromotionPosition.SEARCH_PAGE") },
    { id: "3", name: t("marketingPromotionPosition.PRODUCT_DETAILS_PAGE") },
    { id: "4", name: t("marketingPromotionPosition.MY_ADS_PAGE") },
    { id: "5", name: t("marketingPromotionPosition.LIKED_ADS_PAGE") },
    { id: "6", name: t("marketingPromotionPosition.PROFILE_USER_PAGE") },
  ];


export {navigationItems, categoiresColumns, statusOfCategories, inputsColumns, typeOfInputs, packagesColumns, positionOfPackags, shapOfPackags, TopResultOfPackags, usersColumns, stateOfusers, ordersColumns, stateOfOrders, adsColumns, typeOfUsers, typeOfAds, categoriesBolgColumns, bolgColumns, statusOfCategoriesBlog, positionOfCategoiresBlog, paymentMethodColumns, rolesColumns, employeesColumns, numberOfData, typeOfcurrency, reportsColumns, reportType, pageColumns, pageSectionColumns, bannerColumns, marketingColumns, devices, marketingPromotionPosition};
